import IconGlutenfree from './assets/icon-glutenfree.png'
import IconKeto from './assets/icon-keto.png'
import IconMeat from './assets/icon-meat.png'
import IconPaleo from './assets/icon-paleo.png'
import IconPoultry from './assets/icon-poultry.png'
import IconSeafood from './assets/icon-seafood.png'
import IconVegan from './assets/icon-vegan.png'
import IconVegetarian from './assets/icon-vegetarian.png'
import IconWhole30 from './assets/icon-whole30.png'

export const getCategoryTag = category => {
  const categoryMap = {
    glutenfree: { icon: IconGlutenfree, label: 'Gluten Free' },
    keto: { icon: IconKeto, label: 'Keto Diet' },
    meat: { icon: IconMeat, label: 'Meat' },
    paleo: { icon: IconPaleo, label: 'Paleo' },
    poultry: { icon: IconPoultry, label: 'Poultry' },
    seafood: { icon: IconSeafood, label: 'Seafood' },
    vegan: { icon: IconVegan, label: 'Vegan' },
    vegetarian: { icon: IconVegetarian, label: 'Vegetarian' },
    whole30: { icon: IconWhole30, label: 'Whole 30' }
  }
  return categoryMap[category.toLowerCase()]
}



// WEBPACK FOOTER //
// ./src/components/MealCard/utils.js